/* eslint-disable no-param-reassign */
import { util } from 'echarts';
import type { PresetMode } from '../..';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';

function getDefaultLineSeries(
  seriesIndex: number,
  lineSeries,
  option: Parameters<ThemeParser>[0],
  themeMode: PresetMode
) {
  return {
    /** 折线标签超过五个不显示 */
    dvMaxLabelCount: 5,
    /** 折线节点超过13个不再显示symbol */
    dvShowSymbolStrategy: 13,
    symbol: 'circle',
    symbolSize: 6,
    lineStyle: {
      width: 2
    },
    itemStyle: {
      borderColor: option.color[seriesIndex],
      borderWidth: 2
    },
    label: {
      show: true,
      fontSize: 10,
      lineHeight: 12,
      fontWeight: 500,
      distance: 4,
      color: themeMode === 'light' ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)'
    },
    emphasis: {
      scale: false,
      itemStyle: {
        color: themeMode === 'light' ? '#fff' : '#171717',
        borderColor: option.color[seriesIndex],
        borderWidth: 2
      }
    },
    areaStyle:
      lineSeries.id === 'mainLine'
        ? {
            origin: 'start',
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 1,
                  color: 'rgba(38, 95, 252, 0)'
                },
                {
                  offset: 0,
                  color: 'rgba(38, 95, 252, 0.18)'
                }
              ]
            }
          }
        : undefined,
    animation: false
  };
}

function parseLineSeries(
  seriesOptions: Parameters<ThemeParser>[0]['series'],
  option: Parameters<ThemeParser>[0],
  chart: Parameters<ThemeParser>[1],
  themeMode: PresetMode
) {
  (seriesOptions as []).forEach((series, index) => {
    if (series.type !== 'line') {
      return;
    }
    const defaultOption = getDefaultLineSeries(index, series, option, themeMode);
    seriesOptions[index] = util.merge(defaultOption, series, true);
  });
}

export function lineThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  option.series = normalizeToArray(option.series);
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';

  parseLineSeries(option.series, option, chart, themeMode);
}
